import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import { IUpdateMaterialType } from "./interfaces/update-material-type.interface";
import { ICreateMaterialType } from "./interfaces/create-material-type.interface";
import MaterialTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-type/material-type.entity";

const apiUrl = env.API_MATERIAL_URL;
const moduleName = "material_type";

@Injectable({
  providedIn: "root",
})
export class MaterialTypeService extends AbstractService<
  MaterialTypeAttributes,
  ICreateMaterialType,
  IUpdateMaterialType
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<MaterialTypeAttributes>, 
  ): Observable<IPaginationResult<MaterialTypeAttributes>> {
  
    const query = buildQuery<MaterialTypeAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("code", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      orWhere(<any>"externalKeys.code", Ops.like(options.search ?? "", "i")),

      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<MaterialTypeAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<MaterialTypeAttributes[]>> {
    const query = buildQuery<MaterialTypeAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      select(["code", "name"]),
      orderBy("code", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<MaterialTypeAttributes[]>>(API_URL);
  }
}
